import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Tv, Wind, UtensilsCrossed, Fan, Speaker } from 'lucide-react';

const CategoryCard = ({ category, onClick, language }) => {
  const iconMap = {
    Tv: Tv,
    Wind: Wind,
    UtensilsCrossed: UtensilsCrossed,
    Fan: Fan,
    Speaker: Speaker
  };

  const IconComponent = iconMap[category.icon];

  return (
    <Card 
      className="group overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-2xl hover:scale-105 animate-in fade-in slide-in-from-bottom-4"
      onClick={onClick}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        {category.image && (
          <img
            src={category.image}
            alt={category.name[language]}
            className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110"
          />
        )}
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
        
        {/* Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
          <div className="w-16 h-16 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110">
            {IconComponent && <IconComponent className="h-8 w-8 text-foreground" />}
          </div>
          <h3 className="text-2xl font-bold text-white drop-shadow-lg">
            {category.name[language]}
          </h3>
        </div>
      </div>
    </Card>
  );
};

export default CategoryCard;
